import { render } from "./MainSettings.vue?vue&type=template&id=33f8c78f&scoped=true"
import script from "./MainSettings.vue?vue&type=script&lang=js"
export * from "./MainSettings.vue?vue&type=script&lang=js"

import "./MainSettings.vue?vue&type=style&index=0&id=33f8c78f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f8c78f"]])

export default __exports__